import BOSHomeButton from 'Components/Generic/Navigation/BOSHomeButton';
import { NAVIGATION, SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import { isUserAuthorized } from 'Util';
import TopNavMenuBar from './TopNavMenuBar';

const { navbarLinks, userAccountLinks, navbarRightLinks_LoggedOut } =
  NAVIGATION;

const BOSNavbar = ({ isLoggedIn, userName, showHome = false }) => {
  let leftMenuItems = isLoggedIn
    ? navbarLinks.filter((page) => isUserAuthorized(page.requiredAuth))
    : [];

  return (
    <TopNavMenuBar
      darkMode={isLoggedIn}
      homeButton={showHome ? <BOSHomeButton /> : undefined}
      leftMenuItems={leftMenuItems}
      userAccountMenuItems={isLoggedIn ? userAccountLinks : undefined}
      rightMenuItems={!isLoggedIn ? navbarRightLinks_LoggedOut : undefined}
      helpMenuItem={SITE_PAGES.HELP}
      userName={userName}
    />
  );
};

BOSNavbar.propTypes = {
  isLoggedIn: PropTypes.bool,
  userName: PropTypes.string,
  showHome: PropTypes.bool,
};

export default BOSNavbar;
